import { InjectionToken, Injectable, Inject, defineInjectable, inject, Component, ElementRef, ChangeDetectorRef, NgZone, Input, HostListener, Directive, ContentChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, tap, filter, takeUntil, throttleTime } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = [3, "innerHTML"];
const _c1 = ["class", "svg-root", "x", "0px", "y", "0px", 4, "ngIf"];
const _c2 = ["x", "0px", "y", "0px", 1, "svg-root"];
const _c3 = ["stop-opacity", "0", "offset", "0", 1, "stop", "stop--1"];
const _c4 = ["stop-opacity", "1", "offset", "50%", 1, "stop", "stop--2"];
const _c5 = ["stop-opacity", "0", "offset", "100%", 1, "stop", "stop--3"];
const _c6 = [4, "ngFor", "ngForOf"];
const _c7 = ["x", "0", "y", "0", "width", "100%", "height", "100%", 1, "bg-fill"];
const _c8 = ["y", "0", "height", "100%", 1, "skltn-flare"];
const _c9 = ["fill", "#FFFFFF", 4, "ngIf"];
const _c10 = [4, "ngIf"];
const _c11 = ["fill", "#FFFFFF"];
function SkltnComponent__svg_svg_1__svg_ng_container_7__svg_rect_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "rect", _c11);
} if (rf & 2) {
    const shape_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵattribute("x", shape_r4.x)("y", shape_r4.y)("rx", shape_r4.rx)("ry", shape_r4.ry)("width", shape_r4.width)("height", shape_r4.height);
} }
function SkltnComponent__svg_svg_1__svg_ng_container_7__svg_ellipse_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "ellipse", _c11);
} if (rf & 2) {
    const shape_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵattribute("cx", shape_r4.cx)("cy", shape_r4.cy)("rx", shape_r4.rx)("ry", shape_r4.ry);
} }
const _c12 = [4, "ngTemplateOutlet"];
function SkltnComponent__svg_svg_1__svg_ng_container_7__svg_ng_container_3__svg_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementContainer(0);
} }
function SkltnComponent__svg_svg_1__svg_ng_container_7__svg_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "g", _c11);
    ɵngcc0.ɵɵtemplate(2, SkltnComponent__svg_svg_1__svg_ng_container_7__svg_ng_container_3__svg_ng_container_2_Template, 1, 0, "ng-container", _c12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const shape_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵselect(1);
    ɵngcc0.ɵɵattribute("transform", shape_r4.transform);
    ɵngcc0.ɵɵselect(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", shape_r4.template);
} }
function SkltnComponent__svg_svg_1__svg_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SkltnComponent__svg_svg_1__svg_ng_container_7__svg_rect_1_Template, 1, 6, "rect", _c9);
    ɵngcc0.ɵɵtemplate(2, SkltnComponent__svg_svg_1__svg_ng_container_7__svg_ellipse_2_Template, 1, 4, "ellipse", _c9);
    ɵngcc0.ɵɵtemplate(3, SkltnComponent__svg_svg_1__svg_ng_container_7__svg_ng_container_3_Template, 3, 2, "ng-container", _c10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const shape_r4 = ctx.$implicit;
    ɵngcc0.ɵɵselect(1);
    ɵngcc0.ɵɵproperty("ngIf", shape_r4.type === "rect");
    ɵngcc0.ɵɵselect(2);
    ɵngcc0.ɵɵproperty("ngIf", shape_r4.type === "circle");
    ɵngcc0.ɵɵselect(3);
    ɵngcc0.ɵɵproperty("ngIf", shape_r4.type === "path");
} }
function SkltnComponent__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", _c2);
    ɵngcc0.ɵɵelementStart(1, "linearGradient");
    ɵngcc0.ɵɵelement(2, "stop", _c3);
    ɵngcc0.ɵɵelement(3, "stop", _c4);
    ɵngcc0.ɵɵelement(4, "stop", _c5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "defs");
    ɵngcc0.ɵɵelementStart(6, "mask");
    ɵngcc0.ɵɵtemplate(7, SkltnComponent__svg_svg_1__svg_ng_container_7_Template, 4, 3, "ng-container", _c6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "g");
    ɵngcc0.ɵɵelement(9, "rect", _c7);
    ɵngcc0.ɵɵelement(10, "rect", _c8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("viewBox", ctx_r2.viewBox);
    ɵngcc0.ɵɵselect(1);
    ɵngcc0.ɵɵattribute("id", ctx_r2.gradientId);
    ɵngcc0.ɵɵselect(2);
    ɵngcc0.ɵɵattribute("stop-color", ctx_r2.flareFill);
    ɵngcc0.ɵɵselect(3);
    ɵngcc0.ɵɵattribute("stop-color", ctx_r2.flareFill);
    ɵngcc0.ɵɵselect(4);
    ɵngcc0.ɵɵattribute("stop-color", ctx_r2.flareFill);
    ɵngcc0.ɵɵselect(6);
    ɵngcc0.ɵɵattribute("id", ctx_r2.maskId);
    ɵngcc0.ɵɵselect(7);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.shapes);
    ɵngcc0.ɵɵselect(8);
    ɵngcc0.ɵɵattribute("mask", "url(" + ctx_r2.href + "#" + ctx_r2.maskId + ")");
    ɵngcc0.ɵɵselect(9);
    ɵngcc0.ɵɵattribute("fill", ctx_r2.bgFill);
    ɵngcc0.ɵɵselect(10);
    ɵngcc0.ɵɵattribute("x", "-" + ctx_r2.flareWidth)("width", ctx_r2.flareWidth)("fill", "url(" + ctx_r2.href + "#" + ctx_r2.gradientId + ")");
} }
const _c13 = ["*"];
const _c14 = ["boneTemp"];
const SKLTN_CONFIG_TOKEN = new InjectionToken('SkltnConfig');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SkltnService {
    /**
     * @param {?} config
     */
    constructor(config) {
        this.ids = [];
        this.defaultConfig = {
            rectRadius: 4,
            bgFill: '#ddd',
            flareFill: 'rgba(255, 255, 255, 0.6)',
            flareWidth: '150px',
            duration: 1200,
            delay: 0,
            timing: 'ease-in-out',
        };
        this.config = Object.assign({}, this.defaultConfig, config);
    }
}
SkltnService.ngInjectableDef = ɵngcc0.ɵɵdefineInjectable({ token: SkltnService, factory: function SkltnService_Factory(t) { return new (t || SkltnService)(ɵngcc0.ɵɵinject(SKLTN_CONFIG_TOKEN)); }, providedIn: 'root' });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(SkltnService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [SKLTN_CONFIG_TOKEN]
            }] }]; }, { constructor: [], ids: [], defaultConfig: [], config: [] });
/** @nocollapse */
SkltnService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [SKLTN_CONFIG_TOKEN,] }] }
];
/** @nocollapse */ SkltnService.ngInjectableDef = defineInjectable({ factory: function SkltnService_Factory() { return new SkltnService(inject(SKLTN_CONFIG_TOKEN)); }, token: SkltnService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function generateId() {
    return Math.random().toString(32).substr(2, 4);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BonesList {
    constructor() {
        this.changes = new BehaviorSubject([]);
        this.map = new Map();
    }
    /**
     * @param {?} elRef
     * @return {?}
     */
    add(elRef) {
        /** @type {?} */
        const id = generateId();
        this.map.set(id, elRef);
        this.emit();
        return id;
    }
    /**
     * @param {?} id
     * @return {?}
     */
    remove(id) {
        this.map.delete(id);
        this.emit();
    }
    /**
     * @private
     * @return {?}
     */
    emit() {
        /** @type {?} */
        const elementList = this.getElementList();
        this.changes.next(elementList);
    }
    /**
     * @private
     * @return {?}
     */
    getElementList() {
        /** @type {?} */
        const values = this.map.values();
        return Array.from(values);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SkltnComponent {
    /**
     * @param {?} skltnService
     * @param {?} element
     * @param {?} sanitizer
     * @param {?} cd
     * @param {?} zone
     * @param {?} bonesList
     */
    constructor(skltnService, element, sanitizer, cd, zone, bonesList) {
        this.skltnService = skltnService;
        this.element = element;
        this.sanitizer = sanitizer;
        this.cd = cd;
        this.zone = zone;
        this.bonesList = bonesList;
        this.showSkltn = true;
        this.checkInterval = 100;
        this.updStream$ = new Subject();
        this.checkStream$ = new Subject();
        this.unsubscribe$ = new Subject();
        this.defaultConfig = {
            rectRadius: 4,
            bgFill: '#ddd',
            flareFill: 'rgba(255, 255, 255, 0.6)',
            flareWidth: '150px',
            duration: 1200,
            delay: 0,
            timing: 'ease-in-out',
        };
        /** @type {?} */
        const conf = this.skltnService.config;
        this.rectRadius = conf.rectRadius;
        this.bgFill = conf.bgFill;
        this.flareFill = conf.flareFill;
        this.flareWidth = conf.flareWidth;
        this.duration = conf.duration;
        this.delay = conf.delay;
        this.timing = conf.timing;
        this.sufix = this.getSufixWithID();
        this.gradientId = 'gradient-' + this.sufix;
        this.maskId = 'mask-' + this.sufix;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onResize(event) {
        this.updStream$.next();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.animationCss = this.sanitizer.bypassSecurityTrustHtml(`
    <style>
    @keyframes skltnFlareAnimation {
        0% { x: calc(0% - ${this.flareWidth}); }
        100% { x: 100%; }
    }
    .skltn-flare {
      animation-name: skltnFlareAnimation;
      animation-duration: ${this.duration}ms;
      animation-timing-function: ${this.timing};
      animation-iteration-count: infinite;
      animation-delay: ${this.delay}ms;
    }
    </style>`);
        // Bones Updates
        this.bonesList.changes.pipe(debounceTime(50), tap((/**
         * @param {?} list
         * @return {?}
         */
        list => {
            this.bones = list;
            this.calcShapes();
            this.cd.detectChanges();
        })), filter((/**
         * @param {?} list
         * @param {?} index
         * @return {?}
         */
        (list, index) => index === 0)), tap((/**
         * @return {?}
         */
        () => {
            this.checkStream$.next();
        })), takeUntil(this.unsubscribe$)).subscribe();
        // Update
        this.updStream$.pipe(throttleTime(50), takeUntil(this.unsubscribe$)).subscribe((/**
         * @return {?}
         */
        () => this.calcShapes()));
        // Update href (Safari Bug, SVG Ref Path)
        this.href = window.location.href;
        this.zone.runOutsideAngular((/**
         * @return {?}
         */
        () => {
            this.checkStream$.pipe(tap((/**
             * @return {?}
             */
            () => {
                // Check if href changed
                if (this.href !== window.location.href) {
                    this.href = window.location.href;
                    this.cd.detectChanges();
                }
                // Check if root element resized
                /** @type {?} */
                const el = this.element.nativeElement;
                const { width, height } = el.getBoundingClientRect();
                if (this.parentClientRect.width !== width || this.parentClientRect.height !== height) {
                    this.updStream$.next();
                    this.cd.detectChanges();
                }
                setTimeout((/**
                 * @return {?}
                 */
                () => {
                    this.checkStream$.next();
                }), this.checkInterval);
            })), takeUntil(this.unsubscribe$)).subscribe();
        }));
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    /**
     * @return {?}
     */
    getSufixWithID() {
        return generateId() + '-skltn';
    }
    /**
     * @return {?}
     */
    calcShapes() {
        // Root SVG Element
        /** @type {?} */
        const el = this.element.nativeElement;
        this.parentClientRect = el.getBoundingClientRect();
        this.viewBox = `0 0 ${this.parentClientRect.width} ${this.parentClientRect.height}`;
        // SVG Shapes
        this.shapes = this.bones.map((/**
         * @param {?} bone
         * @return {?}
         */
        bone => {
            /** @type {?} */
            const boneEl = bone.element.nativeElement;
            /** @type {?} */
            const clientRect = boneEl.getBoundingClientRect();
            /** @type {?} */
            const radius = bone.rectRadius || this.rectRadius;
            if (bone.type === 'circle') {
                return {
                    type: 'circle',
                    cx: clientRect.x - this.parentClientRect.x + clientRect.width / 2,
                    cy: clientRect.y - this.parentClientRect.y + clientRect.height / 2,
                    rx: clientRect.width / 2,
                    ry: clientRect.height / 2,
                };
            }
            if (bone.type === 'path') {
                /** @type {?} */
                const x = clientRect.x - this.parentClientRect.x;
                /** @type {?} */
                const y = clientRect.y - this.parentClientRect.y;
                /** @type {?} */
                let transform = `translate(${x}, ${y})`;
                if (bone.pathWidth && bone.pathHeight) {
                    /** @type {?} */
                    const xScale = (clientRect.width / bone.pathWidth).toFixed(2);
                    /** @type {?} */
                    const yScale = (clientRect.height / bone.pathHeight).toFixed(2);
                    transform += ` scale(${xScale}, ${yScale})`;
                }
                return {
                    type: 'path',
                    width: clientRect.width,
                    height: clientRect.height,
                    transform,
                    template: bone.template,
                };
            }
            return {
                type: 'rect',
                x: clientRect.x - this.parentClientRect.x,
                y: clientRect.y - this.parentClientRect.y,
                width: clientRect.width,
                height: clientRect.height,
                rx: radius,
                ry: radius,
            };
        }));
    }
}
SkltnComponent.ngComponentDef = ɵngcc0.ɵɵdefineComponent({ type: SkltnComponent, selectors: [["skltn-root"]], factory: function SkltnComponent_Factory(t) { return new (t || SkltnComponent)(ɵngcc0.ɵɵdirectiveInject(SkltnService), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(DomSanitizer), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(NgZone), ɵngcc0.ɵɵdirectiveInject(BonesList)); }, hostBindings: function SkltnComponent_HostBindings(rf, ctx, elIndex) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function SkltnComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { showSkltn: "showSkltn", checkInterval: "checkInterval", rectRadius: "rectRadius", bgFill: "bgFill", flareFill: "flareFill", flareWidth: "flareWidth", duration: "duration", delay: "delay", timing: "timing" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: BonesList,
                useClass: BonesList
            }])], ngContentSelectors: _c13, consts: 3, vars: 2, template: function SkltnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "div", _c0);
        ɵngcc0.ɵɵtemplate(1, SkltnComponent__svg_svg_1_Template, 11, 12, "svg", _c1);
        ɵngcc0.ɵɵprojection(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("innerHTML", ctx.animationCss, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵselect(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.shapes == null ? null : ctx.shapes.length) && ctx.showSkltn);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet], styles: ["[_nghost-%COMP%]{display:block;position:relative}.svg-root[_ngcontent-%COMP%]{display:block;position:absolute;top:0;bottom:0;left:0;right:0;z-index:1}"] });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(SkltnComponent, [{
        type: Component,
        args: [{
                selector: 'skltn-root',
                template: "<div [innerHTML]=\"animationCss\"></div>\n\n<svg class=\"svg-root\" x=\"0px\" y=\"0px\" [attr.viewBox]=\"viewBox\" *ngIf=\"shapes?.length && showSkltn\">\n\n  <!-- Gradient -->\n  <linearGradient [attr.id]=\"gradientId\">\n      <stop class=\"stop stop--1\" [attr.stop-color]=\"flareFill\" stop-opacity=\"0\" offset=\"0\"></stop>\n      <stop class=\"stop stop--2\" [attr.stop-color]=\"flareFill\" stop-opacity=\"1\" offset=\"50%\"></stop>\n      <stop class=\"stop stop--3\" [attr.stop-color]=\"flareFill\" stop-opacity=\"0\" offset=\"100%\"></stop>\n    </linearGradient>\n\n  <defs>\n    <!-- Mask -->\n    <mask [attr.id]=\"maskId\">\n      <!-- Shapes -->\n      <ng-container *ngFor=\"let shape of shapes\">\n        <!-- Rect Type -->\n        <rect *ngIf=\"shape.type === 'rect'\" [attr.x]=\"shape.x\" [attr.y]=\"shape.y\" [attr.rx]=\"shape.rx\"\n          [attr.ry]=\"shape.ry\" [attr.width]=\"shape.width\" [attr.height]=\"shape.height\" fill=\"#FFFFFF\" />\n        <!-- Circle Type -->\n        <ellipse *ngIf=\"shape.type === 'circle'\" [attr.cx]=\"shape.cx\" [attr.cy]=\"shape.cy\" [attr.rx]=\"shape.rx\" [attr.ry]=\"shape.ry\" fill=\"#FFFFFF\"></ellipse>\n        <!-- Path Type -->\n        <ng-container *ngIf=\"shape.type === 'path'\">\n          <g fill=\"#FFFFFF\" [attr.transform]=\"shape.transform\">\n            <ng-container *ngTemplateOutlet=\"shape.template\"></ng-container>\n          </g>\n        </ng-container>\n      </ng-container>\n    </mask>\n  </defs>\n\n  <g [attr.mask]=\"'url(' + href + '#' + maskId + ')'\">\n    <!-- Background Rectangle -->\n    <rect class=\"bg-fill\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" [attr.fill]=\"bgFill\"></rect>\n\n    <!-- Flare -->\n    <rect class=\"skltn-flare\" [attr.x]=\"'-' + flareWidth\" y=\"0\" [attr.width]=\"flareWidth\" height=\"100%\" [attr.fill]=\"'url(' + href + '#' + gradientId + ')'\"></rect>\n  </g>\n\n</svg>\n\n<ng-content></ng-content>\n",
                providers: [{
                        provide: BonesList,
                        useClass: BonesList
                    }],
                styles: [":host{display:block;position:relative}.svg-root{display:block;position:absolute;top:0;bottom:0;left:0;right:0;z-index:1}"]
            }]
    }], function () { return [{ type: SkltnService }, { type: ElementRef }, { type: DomSanitizer }, { type: ChangeDetectorRef }, { type: NgZone }, { type: BonesList }]; }, { constructor: [], skltnService: [], element: [], sanitizer: [], cd: [], zone: [], bonesList: [], showSkltn: [{
            type: Input
        }], checkInterval: [{
            type: Input
        }], updStream$: [], checkStream$: [], unsubscribe$: [], defaultConfig: [], rectRadius: [{
            type: Input
        }], bgFill: [{
            type: Input
        }], flareFill: [{
            type: Input
        }], flareWidth: [{
            type: Input
        }], duration: [{
            type: Input
        }], delay: [{
            type: Input
        }], timing: [{
            type: Input
        }], sufix: [], gradientId: [], maskId: [], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], ngOnInit: [], animationCss: [], bones: [], href: [], ngAfterViewInit: [], ngOnDestroy: [], getSufixWithID: [], calcShapes: [], parentClientRect: [], viewBox: [], shapes: [] });
/** @nocollapse */
SkltnComponent.ctorParameters = () => [
    { type: SkltnService },
    { type: ElementRef },
    { type: DomSanitizer },
    { type: ChangeDetectorRef },
    { type: NgZone },
    { type: BonesList }
];
SkltnComponent.propDecorators = {
    rectRadius: [{ type: Input }],
    bgFill: [{ type: Input }],
    flareFill: [{ type: Input }],
    flareWidth: [{ type: Input }],
    duration: [{ type: Input }],
    delay: [{ type: Input }],
    timing: [{ type: Input }],
    showSkltn: [{ type: Input }],
    checkInterval: [{ type: Input }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SkltnBoneDirective {
    /**
     * @param {?} element
     * @param {?} bonesList
     */
    constructor(element, bonesList) {
        this.element = element;
        this.bonesList = bonesList;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.id = this.bonesList.add(this);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.bonesList.remove(this.id);
    }
}
SkltnBoneDirective.ngDirectiveDef = ɵngcc0.ɵɵdefineDirective({ type: SkltnBoneDirective, selectors: [["", "skltn-bone", ""]], factory: function SkltnBoneDirective_Factory(t) { return new (t || SkltnBoneDirective)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(BonesList)); }, contentQueries: function SkltnBoneDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c14, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadContentQuery()) && (ctx.template = _t.first);
    } }, inputs: { type: "type", rectRadius: "rectRadius", pathWidth: "pathWidth", pathHeight: "pathHeight" } });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(SkltnBoneDirective, [{
        type: Directive,
        args: [{
                selector: '[skltn-bone]'
            }]
    }], function () { return [{ type: ElementRef }, { type: BonesList }]; }, { constructor: [], element: [], bonesList: [], ngOnInit: [], id: [], ngOnDestroy: [], type: [{
            type: Input
        }], rectRadius: [{
            type: Input
        }], pathWidth: [{
            type: Input
        }], pathHeight: [{
            type: Input
        }], template: [{
            type: ContentChild,
            args: ['boneTemp']
        }] });
/** @nocollapse */
SkltnBoneDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: BonesList }
];
SkltnBoneDirective.propDecorators = {
    type: [{ type: Input }],
    rectRadius: [{ type: Input }],
    pathWidth: [{ type: Input }],
    pathHeight: [{ type: Input }],
    template: [{ type: ContentChild, args: ['boneTemp',] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxSkltnModule {
    /**
     * @param {?=} config
     * @return {?}
     */
    static forRoot(config = {}) {
        return {
            ngModule: NgxSkltnModule,
            providers: [{
                    provide: SKLTN_CONFIG_TOKEN,
                    useValue: config,
                },
                {
                    provide: SkltnService,
                    useClass: SkltnService,
                    deps: [SKLTN_CONFIG_TOKEN],
                }]
        };
    }
}
NgxSkltnModule.ngModuleDef = ɵngcc0.ɵɵdefineNgModule({ type: NgxSkltnModule });
/*@__PURE__*/ ɵngcc0.ɵɵsetNgModuleScope(NgxSkltnModule, { declarations: function () { return [SkltnComponent,
        SkltnBoneDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SkltnComponent,
        SkltnBoneDirective]; } });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(NgxSkltnModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SkltnComponent,
                    SkltnBoneDirective,
                ],
                imports: [
                    CommonModule,
                ],
                exports: [
                    SkltnComponent,
                    SkltnBoneDirective,
                ]
            }]
    }], null, null);
NgxSkltnModule.ngInjectorDef = ɵngcc0.ɵɵdefineInjector({ factory: function NgxSkltnModule_Factory(t) { return new (t || NgxSkltnModule)(); }, imports: [[
            CommonModule,
        ]] });

export { NgxSkltnModule, SKLTN_CONFIG_TOKEN, SkltnBoneDirective, SkltnComponent, SkltnService, BonesList as ɵa };

//# sourceMappingURL=ngx-skltn.js.map